/*
 * 作业管理接口
 * */
import services from "../config/axios";
import base from "./base";
// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const jobManageAPI = {
    // 获取流程调度清单
    getProcessTakeList<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetProcessTakeList`, params);
    },
    // 获取流程调度清单
    getProcessTakeListMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Job/GetProcessTakeList`, params);
    },
    //获取jobs list
    getJobsList<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetJobsList`, params);
    },
    // 保存执行记录跟进信息
    saveJobFollow<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SaveJobFollow`, params);
    },
    //获取jobs list
    getJobsListMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Job/GetJobsList`, params);
    },
    //获取jobs list
    getJobsListQuality<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetJobsListQuality`, params);
    },
    //获取logs
    getLogsList<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetLogsList`, params);
    },
    //获取logs
    getLogsListMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Job/GetLogsList`, params);
    },
    //获取排队情况
    getQueueList<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetQueueList`, params);
    },
    //获取排队情况
    getQueueListMobile<T>(params: FormData) {
        return services.post(`${base.lkmobile}/Job/GetQueueList`, params);
    },
    //取消排队
    delQueueItem<T>(params: FormData) {
        return services.post(`${base.lk}/Job/DelQueueItem`, params);
    },
    //启动流程
    startProcess<T>(params: FormData) {
        return services.post(`${base.lk}/Job/StartProcess`, params);
    },
    //启动流程Python
    startProcessPython<T>(params: FormData) {
        return services.post(`${base.lk}/Job/StartProcessPython`, params);
    },
    stopJob<T>(params: FormData) {
        return services.post(`${base.lk}/Job/StopJob`, params);
    },
    stopJobPython<T>(params: FormData) {
        return services.post(`${base.lk}/Job/StopJobPython`, params);
    },
    //更新机器人头像
    updateRobotPhoto<T>(params: FormData) {
        return services.post(`${base.lk}/Job/UpdateRobotPhoto`, params);
    },
    //更新python机器人头像
    updatePythonRobotPhoto<T>(params: FormData) {
        return services.post(`${base.lk}/Job/UpdatePythonRobotPhoto`, params);
    },
    //更新数字员工头像
    updateDEmpPhoto<T>(params: FormData) {
        return services.post(`${base.lk}/Job/UpdateDEmpPhoto`, params);
    },
    //保存
    saveRobotAlias<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SaveRobotAlias`, params);
    },
    //保存 python 机器人别名
    savePythonRobotAlias<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SavePythonRobotAlias`, params);
    },
    //设置隐藏
    setRobotHidden<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SetRobotHidden`, params);
    },
    //设置隐藏
    setPythonRobotHidden<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SetPythonRobotHidden`, params);
    },
    //保存我的数字员工信息
    saveDEmpSetting<T>(params: FormData) {
        return services.post(`${base.lk}/Job/SaveDEmpSetting`, params);
    },
    // 获取流程调度清单python
    getProjectTakeList<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetProjectTakeList`, params);
    },
    //获取jobs list Python
    getJobsListPython<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetJobsListPython`, params);
    },
    //获取本地jobs list
    getJobsListLocal<T>(params: FormData) {
        return services.post(`${base.lk}/Job/GetJobsListLocal`, params);
    },
};

export default jobManageAPI;
